import { Prediction } from 'tripPlanner/hooks/Google/usePlaceAutocomplete'
import { Place, TripMetadata } from 'tripPlanner/types/common'

export const isSamePlace = (place1: Place, place2: Place): boolean =>
  'id' in place1 && 'id' in place2 && place1.id === place2.id

export const getUniquePredictions = (
  predictions: Prediction[],
  limit = 6,
): Prediction[] => {
  const uniquePredictions: Prediction[] = []
  const seenIds: Set<string> = new Set()

  for (const prediction of predictions) {
    if (!seenIds.has(prediction.place_id)) {
      uniquePredictions.push(prediction)
      seenIds.add(prediction.place_id)
    }
  }
  return uniquePredictions.slice(0, limit)
}

export const getCountryCodes = (data: TripMetadata | undefined): string[] => {
  if (!data || !data.locations) {
    return []
  }

  const countryCodes = data.locations
    .map((loc) => loc.country?.leCountryCode?.toLowerCase() || undefined)
    .filter((code, index, array) => code && array.indexOf(code) === index)
  return countryCodes as string[]
}
